/**
 * tableFormat — shared value formatters for External tables, so currency /
 * percent / per_1k / date all render identically across DataTable, CSV, and PDF.
 * A column's `format(value, row)` override always wins; otherwise `type` drives it.
 */

export function formatDate(val) {
  if (!val) return '—'
  // CALENDAR dates: parse YYYY-MM-DD as LOCAL (never UTC) to avoid the
  // west-of-UTC off-by-one. Matches External_TOC_Page.formatDate.
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(val))
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(val)
  return isNaN(d) ? '—' : d.toLocaleDateString('en-US')
}

export function formatCurrency(val) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  return Number(val).toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
}

export function formatPercent(val) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  return `${Number(val).toFixed(1)}%`
}

export function formatNumber(val) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  return Number(val).toLocaleString('en-US')
}

export function formatPer1k(val) {
  if (val == null || val === '' || Number.isNaN(Number(val))) return '—'
  return Number(val).toLocaleString('en-US', { maximumFractionDigits: 1 })
}

/**
 * The single display resolver every renderer/exporter calls.
 * Returns a STRING for a given column + row.
 */
export function formatCell(col, row) {
  const val = row[col.field]
  if (typeof col.format === 'function') return col.format(val, row)
  switch (col.type) {
    case 'currency': return formatCurrency(val)
    case 'percent': return formatPercent(val)
    case 'per_1k': return formatPer1k(val)
    case 'number': return formatNumber(val)
    case 'date': return formatDate(val)
    default: return val == null || val === '' ? '—' : String(val)
  }
}
